module.exports = __webpack_public_path__ + "img/vip-banner-bg.d4c66efa.png";